import http from "../../baseUrl/httpcommon";

const users = (userId) => {
  return http.get("/api/users/" + userId);
};

const blockedUser = (userId) => {
  return http.get("/api/users/22/blocked");
};

const profile = (userId, image) => {
  const formData = new FormData();
  formData.append("image", image);
  return http.put(`/api/users/profile/photo?userId=${userId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadImageGroup = (userId, image) => {
  const formData = new FormData();
  formData.append("image", image);
  return http.put(`/api/users/group/image`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const changePassword = (email, oldPassword, newPassword) => {
  return http.post("/api/users/changepassword", {
    email,
    oldPassword,
    newPassword,
  });
};

const unblockUser = ({ id, userId }) => {
  debugger;
  return http.post(`/api/users/${userId}/unblock/${id}`);
};

const UserService = {
  users,
  profile,
  changePassword,
  blockedUser,
  uploadImageGroup,
  unblockUser,
};

export default UserService;
